<template>
  <div v-html="content" class="content">
  </div>
</template>

<script>

    export default {
        name: "Popupcontent",
      components: {
      },
      data(){
        return{
          content:''
        }
      },
      methods:{
        getActivityDetail(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'sysconfig',
              'name': that.$route.activityid
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.content = resData.data;
              }else{
                // that.$alert('请稍后尝试','提示',{
                //   confirmButtonText: '确定',
                // })
              }
            });
        }
      },
      mounted: function () {
        let that = this;
        this.getActivityDetail();
      },
    }
</script>

<style scoped>
  .content{
    margin: 0 auto;
    text-align: center;
  }
  .content>>>img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/popupcontent.vue